/**
 * Moolk Bundle Widget
 * Impulse 8.1.0 — bundle-widget branch
 *
 * Reads moolk-bundle-config.json, detects if the current product
 * is part of any bundle, fetches partner product data, renders a
 * carousel widget, and handles "add partner to cart" via the
 * Shopify Cart AJAX API. Discount is applied by Supaeasy at checkout.
 *
 * Bundle prices and savings are calculated dynamically from live product
 * prices so they display correctly in any active currency/market.
 */

(function () {
  'use strict';

  // ── Entry point ────────────────────────────────────────────────
  const container = document.querySelector('[data-moolk-bundle-widget]');
  if (!container) return;

  // Guard against double-initialisation if the script is loaded more than once
  // (e.g. once via theme.liquid and once via the snippet). Without this, two
  // separate click listeners are attached to the container and the add-to-cart
  // fires twice per click — adding the partner item twice at two different prices.
  if (container.dataset.moolkInit) return;
  container.dataset.moolkInit = '1';

  const currentProductId = parseInt(container.dataset.productId, 10);
  if (!currentProductId) return;

  // Current product title — set by Liquid via data-product-title, fallback to DOM h1
  var currentProductTitle = (container.dataset.productTitle || '').trim()
    || ((document.querySelector('.product-single__title, .product__title, h1[itemprop="name"]') || {}).textContent || '').trim();

  // Show loading spinner while we fetch
  container.classList.add('moolk-bundle-widget--loading');

  // Config URL is set by the Liquid snippet as window.moolk_config_url
  const configUrl = window.moolk_config_url || '/assets/moolk-bundle-config.json';

  fetch(configUrl + '?v=' + Date.now())
    .then(function (r) {
      if (!r.ok) throw new Error('Config not found');
      return r.json();
    })
    .then(function (config) {
      initWidget(config);
    })
    .catch(function (err) {
      console.warn('[Moolk Bundle] Could not load config:', err.message);
      container.style.display = 'none';
    });


  // ── Step 1: Find matching bundles and partner products ─────────
  function initWidget(config) {
    var cards = [];

    config.bundles.forEach(function (bundle) {
      var isItemA = bundle.item_a_product_ids.indexOf(currentProductId) !== -1;
      var isItemB = bundle.item_b_product_ids.indexOf(currentProductId) !== -1;
      if (!isItemA && !isItemB) return;

      var partnerIds = isItemA ? bundle.item_b_product_ids : bundle.item_a_product_ids;

      partnerIds.forEach(function (partnerId) {
        var productData = config.product_data[String(partnerId)];
        if (!productData) return;

        cards.push({
          bundle: bundle,
          partnerId: partnerId,
          handle: productData.handle,
          style: productData.style,
          colorway: productData.colorway
        });
      });
    });

    if (cards.length === 0) {
      container.style.display = 'none';
      return;
    }

    // Fetch all partner products in parallel
    var fetches = cards.map(function (card) {
      return fetch('/products/' + card.handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Product not found: ' + card.handle);
          return r.json();
        })
        .then(function (product) {
          card.product = product;
          return card;
        })
        .catch(function (err) {
          console.warn('[Moolk Bundle] Could not load product ' + card.handle + ':', err.message);
          return null;
        });
    });

    Promise.all(fetches).then(function (results) {
      var validCards = results.filter(Boolean);
      if (validCards.length === 0) {
        container.style.display = 'none';
        return;
      }
      renderWidget(validCards);
    });
  }


  // ── Step 2: Render the full widget HTML ────────────────────────
  function renderWidget(cards) {
  container.classList.remove('moolk-bundle-widget--loading');
  var cardsHtml = cards.map(function (card, i) {
    return renderCard(card, i);
  }).join('');
  var dotsHtml = '';
  if (cards.length > 1) {
    var dotItems = cards.map(function (_, i) {
      var activeClass = i === 0 ? ' is-active' : '';
      var selected = i === 0 ? 'true' : 'false';
      return '<button class="moolk-bundle-carousel__dot' + activeClass + '" ' +
        'role="tab" aria-selected="' + selected + '" ' +
        'aria-label="Bundle option ' + (i + 1) + '"></button>';
    }).join('');
    dotsHtml =
      '<p class="moolk-bundle-carousel__swipe-hint">SWIPE FOR MORE COLOURS</p>' +
      '<div class="moolk-bundle-carousel__dots" role="tablist">' + dotItems + '</div>';
  }
  var arrowsHtml = cards.length > 1
    ? '<button class="moolk-bundle-carousel__arrow moolk-bundle-carousel__arrow--prev" aria-label="Previous">←</button>' +
      '<button class="moolk-bundle-carousel__arrow moolk-bundle-carousel__arrow--next" aria-label="Next">→</button>'
    : '';

  // Heading: code-based bundles (Dream Sets) get a "use code" header;
  // automatic bundles (Supaeasy-applied) keep the original flat heading.
  var firstBundle = cards[0] && cards[0].bundle;
  var discountCode = firstBundle && firstBundle.discount_code;
  var discountPercent = (firstBundle && firstBundle.discount_percent) || 20;
  var headingHtml = discountCode
    ? 'BUNDLE &amp; SAVE ' + discountPercent + '%<br>Use code ' + esc(discountCode) + ' at checkout'
    : 'BUNDLE + SAVE ' + discountPercent + '%';
    container.dataset.discountPercent = discountPercent;
if (discountCode) {
  container.dataset.discountCode = discountCode;
} else {
  delete container.dataset.discountCode;
}

  container.innerHTML =
    '<h2 class="moolk-bundle-widget__heading">' + headingHtml + '</h2>' +
    '<div class="moolk-bundle-carousel">' +
      arrowsHtml +
      '<div class="moolk-bundle-carousel__track" role="list">' + cardsHtml + '</div>' +
    '</div>' +
    dotsHtml +
    '<p class="moolk-bundle-widget__returns">' +
      'Bundle items purchased at a discount are eligible for store credit or exchange only. Faulty items exempt.' +
    '</p>';
  initCarousel(cards.length);
  initSizeButtons();
  initAddToCart(cards);
}


  // ── Step 3: Render a single card ───────────────────────────────
  function renderCard(card, index) {
  var product = card.product;
  var discountCode = card.bundle.discount_code;

  var images  = product.images || [];
  var src1    = images[0] ? resizeImage(images[0], 600)
              : (product.featured_image ? resizeImage(product.featured_image, 600) : '');
  var src2    = images[1] ? resizeImage(images[1], 600) : '';
  var imgHtml = '';
  if (src1 && src2) {
    imgHtml =
      '<img class="moolk-bundle-card__img" src="' + esc(src1) + '" alt="' + esc(card.style) + '" loading="lazy">' +
      '<img class="moolk-bundle-card__img" src="' + esc(src2) + '" alt="' + esc(card.style) + '" loading="lazy">';
  } else if (src1) {
    imgHtml = '<img class="moolk-bundle-card__img moolk-bundle-card__img--single" src="' + esc(src1) + '" alt="' + esc(card.style) + '" loading="lazy">';
  }

  var sizesHtml = renderSizes(product);
  var pricingHtml = '';
  var partnerNote = '';
  var ctaLabel = 'ADD TO CART';

  if (!discountCode) {
    // Existing automatic-bundle behaviour, unchanged
    var currentPriceCents = getCurrentProductPrice();
    var partnerPriceCents = product.price || 0;
    var combinedCents     = currentPriceCents + partnerPriceCents;
    var discountFraction  = (card.bundle.discount_percent ||20) / 100;
    var bundlePriceCents  = Math.round(combinedCents * (1 - discountFraction));
    var savingCents       = combinedCents - bundlePriceCents;

    pricingHtml =
      '<div class="moolk-bundle-card__pricing">' +
        '<p class="moolk-bundle-card__price-line">Bundle Price: ' + formatMoney(bundlePriceCents) +
          '<span class="moolk-bundle-card__rrp"> ' + formatMoney(combinedCents) + '</span>' +
        '</p>' +
        '<span class="moolk-bundle-card__saving">TOTAL SAVING ' + formatMoney(savingCents) + '</span>' +
      '</div>';

    partnerNote = currentProductTitle
      ? '<p class="moolk-bundle-card__partner-note">Add this with the ' + esc(currentProductTitle) +
          ' to claim your ' + (card.bundle.discount_percent || 20) + '% bundle discount.</p>'
      : '';

    ctaLabel = 'BUNDLE + SAVE ' + formatMoney(savingCents) + ' | ADD TO CART';
  }

  return (
    '<div class="moolk-bundle-card" role="listitem" ' +
      'data-card-index="' + index + '" ' +
      'data-partner-id="' + card.partnerId + '">' +
      '<div class="moolk-bundle-card__image-wrap">' + imgHtml + '</div>' +
      '<a class="moolk-bundle-card__title" href="/products/' + esc(card.handle) + '">' + esc(card.style) + ' — ' + esc(card.colorway) + '</a>' +
      partnerNote +
      pricingHtml +
      '<span class="moolk-bundle-card__size-label">Select size</span>' +
      '<div class="moolk-bundle-card__sizes">' + sizesHtml + '</div>' +
      '<p class="moolk-bundle-widget__error" role="alert"></p>' +
      '<button class="moolk-bundle-card__cta btn btn--primary" data-card-index="' + index + '">' +
        ctaLabel +
      '</button>' +
    '</div>'
  );
}


  // ── Step 4: Build size buttons from product variants ───────────
  function renderSizes(product) {
    if (!product.variants || !product.variants.length) return '';

    // Find which option index is "Size" (fall back to option1)
    var options = product.options || [];
    var sizeOptionIndex = 0;
    options.forEach(function (opt, i) {
      // /products/handle.js returns options as objects {name, position, values},
      // NOT plain strings — extract .name before comparing
      var optName = typeof opt === 'string' ? opt : (opt.name || '');
      if (optName.toLowerCase() === 'size') sizeOptionIndex = i;
    });
    var optionKey = 'option' + (sizeOptionIndex + 1);

    // Deduplicate sizes — prefer available variant for each size value
    var seen = {};
    product.variants.forEach(function (v) {
      var size = v[optionKey];
      if (!size) return;
      if (!seen[size] || (v.available && !seen[size].available)) {
        seen[size] = { variantId: v.id, available: v.available, size: size };
      }
    });

    return Object.keys(seen).map(function (size) {
      var data = seen[size];
      var unavailableClass = data.available ? '' : ' is-unavailable';
      var disabledAttr = data.available ? '' : ' disabled aria-disabled="true"';
      var ariaLabel = esc(data.size) + (data.available ? '' : ' — Unavailable');
      return (
        '<button class="moolk-bundle-size-btn' + unavailableClass + '"' +
          ' data-variant-id="' + data.variantId + '"' +
          ' data-size="' + esc(data.size) + '"' +
          ' aria-label="' + ariaLabel + '"' +
          disabledAttr + '>' +
          esc(data.size) +
        '</button>'
      );
    }).join('');
  }


  // ── Step 5: Carousel logic ─────────────────────────────────────
  function initCarousel(cardCount) {
    if (cardCount <= 1) return;

    var track = container.querySelector('.moolk-bundle-carousel__track');
    var dots  = container.querySelectorAll('.moolk-bundle-carousel__dot');
    if (!track) return;

    var currentIndex = 0;

    function goToIndex(index) {
      var cards = track.querySelectorAll('.moolk-bundle-card');
      if (!cards[index]) return;
      currentIndex = index;
      track.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
      updateDots(index);
    }

    function updateDots(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', String(i === index));
      });
    }

    // Peek-and-bounce: repeats every 3s until the user interacts
    var peekInterval = null;
    var peekActive   = true;

    function stopPeek() {
      peekActive = false;
      if (peekInterval) clearInterval(peekInterval);
    }

    // Stop on touch (mobile swipe) or mousedown (desktop drag/click)
    track.addEventListener('touchstart', stopPeek, { passive: true, once: true });
    track.addEventListener('mousedown',  stopPeek, { once: true });

    function doPeek() {
      if (!peekActive || track.offsetWidth === 0 || currentIndex !== 0) return;
      var peekPx = Math.round(track.offsetWidth * 0.18);
      // Disable scroll-snap temporarily so the peek isn't snapped away instantly
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: peekPx, behavior: 'smooth' });
      setTimeout(function () {
        if (peekActive && currentIndex === 0) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        }
        // Re-enable scroll-snap after the bounce completes
        setTimeout(function () {
          track.style.scrollSnapType = '';
        }, 450);
      }, 650);
    }

    // First peek after 1.8s, then every 3s
    setTimeout(function () {
      doPeek();
      peekInterval = setInterval(doPeek, 3000);
    }, 1800);

    // Arrow clicks (desktop nav)
    var prevBtn = container.querySelector('.moolk-bundle-carousel__arrow--prev');
    var nextBtn = container.querySelector('.moolk-bundle-carousel__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () {
      stopPeek();
      goToIndex(Math.max(0, currentIndex - 1));
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      stopPeek();
      goToIndex(Math.min(cardCount - 1, currentIndex + 1));
    });

    // Dot click
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { stopPeek(); goToIndex(i); });
    });

    // Update dots on scroll (debounced)
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var cardWidth = track.offsetWidth;
        if (cardWidth === 0) return;
        var newIndex = Math.round(track.scrollLeft / cardWidth);
        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < cardCount) {
          currentIndex = newIndex;
          updateDots(currentIndex);
        }
      }, 60);
    }, { passive: true });
  }


  // ── Step 6: Size button selection ──────────────────────────────
  function initSizeButtons() {
    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.moolk-bundle-size-btn');
      if (!btn || btn.disabled) return;

      var card = btn.closest('.moolk-bundle-card');
      if (!card) return;

      // Deselect sibling buttons
      card.querySelectorAll('.moolk-bundle-size-btn').forEach(function (b) {
        b.classList.remove('is-selected');
        b.removeAttribute('aria-pressed');
      });

      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      // Clear any error
      clearError(card);
    });
  }


  // ── Step 7: Detect current product's selected variant ─────────
  // Impulse 8.x can store the selected variant in several places depending
  // on whether the customer has interacted with the picker yet.
  function getCurrentVariantId() {
    // Method 1: Standard hidden input inside the product form
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var input = form.querySelector('input[name="id"], select[name="id"]');
      if (input && input.value) return input.value;
    }

    // Method 2: Any hidden input named "id" on the page (Impulse sometimes
    // renders it outside the <form> element in section wrappers)
    var anyInput = document.querySelector('input[name="id"][type="hidden"]');
    if (anyInput && anyInput.value) return anyInput.value;

    // Method 3: Impulse stores the selected variant in the URL ?variant= param
    var urlMatch = window.location.search.match(/[?&]variant=(\d+)/);
    if (urlMatch) return urlMatch[1];

    // Method 4: Shopify's global analytics object (set by theme.js)
    if (window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.selectedVariantId) {
      return String(window.ShopifyAnalytics.meta.selectedVariantId);
    }

    // Method 5: window.theme.product populated by Impulse theme JS
    if (window.theme && window.theme.product && window.theme.product.variants) {
      var v = window.theme.product.variants.find(function (v) { return v.available; });
      if (v) return String(v.id);
    }

    // Method 6: product-info or variant-selects custom elements (Impulse 8.x Dawn-derived)
    var variantSelects = document.querySelector('variant-selects, variant-radios');
    if (variantSelects) {
      var sel = variantSelects.querySelector('input[type="radio"]:checked, select');
      if (sel && sel.value) return sel.value;
    }

    return null;
  }


  // ── Step 8: Add partner product to cart ───────────────────────
  // Only adds the partner (bundle) product. Customer adds the main product
  // themselves via the regular ATC. Supaeasy applies 15% when both are in cart.
  function initAddToCart(cards) {
    container.addEventListener('click', function (e) {
      var ctaBtn = e.target.closest('.moolk-bundle-card__cta');
      if (!ctaBtn) return;

      var cardIndex = parseInt(ctaBtn.dataset.cardIndex, 10);
      var card = container.querySelector('.moolk-bundle-card[data-card-index="' + cardIndex + '"]');
      if (!card) return;

      // Get partner size selection from widget only — customer adds the main
      // product themselves via the regular ATC; Supaeasy applies the bundle
      // discount when both items are in the cart together.
      var selectedSizeBtn = card.querySelector('.moolk-bundle-size-btn.is-selected');
      var partnerVariantId = selectedSizeBtn && selectedSizeBtn.dataset.variantId;

      // Validate
      if (!partnerVariantId) {
        showError(card, 'Please select a size for the bundle item.');
        return;
      }

      clearError(card);

      // Set loading state
      var originalText = ctaBtn.textContent.trim();
      ctaBtn.textContent = 'Adding...';
      ctaBtn.classList.add('btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(partnerVariantId, 10), quantity: 1 }
          ]
        })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Cart error'); });
        return r.json();
      })
      .then(function () {
        ctaBtn.classList.remove('btn--loading');
        ctaBtn.classList.add('btn--success');
        ctaBtn.textContent = '✓ Added to cart';
        openImpulseCart();
        setTimeout(function () {
          ctaBtn.classList.remove('btn--success');
          ctaBtn.textContent = originalText;
        }, 3500);
      })
      .catch(function (err) {
        ctaBtn.classList.remove('btn--loading');
        ctaBtn.textContent = originalText;
        showError(card, err.message || 'Something went wrong. Please try again.');
      });
    });
  }


  // ── Cart drawer integration (Impulse 8.x) ─────────────────────
  function openImpulseCart() {
    // Method 1: cart-drawer custom element (Impulse 8.x)
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    // Method 2: refresh + open events
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart }, bubbles: true }));
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:toggle', { detail: { open: true }, bubbles: true }));
        }, 150);
      });
  }


  // ── Utilities ──────────────────────────────────────────────────

  // Get the current product's price in cents from the page's variant JSON.
  // Shopify renders this server-side via {{ current_variant | json }}, so it
  // reflects the active market price where Shopify Markets is in use.
  function getCurrentProductPrice() {
    // Preferred: current variant JSON (most accurate)
    var currentEl = document.querySelector('[data-current-variant-json]');
    if (currentEl) {
      try {
        var current = JSON.parse(currentEl.textContent.trim());
        if (current && current.price) return current.price;
      } catch (e) {}
    }
    // Fallback: all-variants JSON, first available variant
    var allEl = document.querySelector('[data-variant-json]');
    if (allEl) {
      try {
        var variants = JSON.parse(allEl.textContent.trim());
        if (variants && variants.length) {
          var found = variants.find(function (v) { return v.available; }) || variants[0];
          if (found && found.price) return found.price;
        }
      } catch (e) {}
    }
    return 0;
  }

  // Format a price in cents using Shopify's own money formatter.
  // Uses Shopify.formatMoney if available (respects active currency symbol),
  // otherwise falls back to the theme money format string.
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    // Manual fallback
    var amount = cents / 100;
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    return fmt
      .replace('{{amount}}', amount.toFixed(2))
      .replace('{{amount_no_decimals}}', Math.round(amount).toString())
      .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount).toString());
  }

  function showError(card, message) {
    var el = card.querySelector('.moolk-bundle-widget__error');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
  }

  function clearError(card) {
    var el = card.querySelector('.moolk-bundle-widget__error');
    if (!el) return;
    el.textContent = '';
    el.classList.remove('is-visible');
  }

  // Resize Shopify CDN image URL
  function resizeImage(src, width) {
    if (!src) return '';
    var separator = src.indexOf('?') !== -1 ? '&' : '?';
    return src + separator + 'width=' + width;
  }

  // Safe HTML escape
  function esc(str) {
    var d = document.createElement('div');
    d.textContent = String(str);
    return d.innerHTML;
  }

})();